<!-- 予約登録枠数マスタ　一括登録画面 -->
<style src="@/assets/css/admin_parts.css" type="text/css" media="all" scoped></style>
<template>
  <div class="contents" id="wwkkrBulk">
    <!-- ▽ -->
    <section id="mainContent">
    <h2>予約登録枠数マスタ<span>期間指定一括登録</span></h2>
			<ul class="contntMenu">
        <li class="onCancel" v-on:click="onCancel">戻る</li>
			</ul>

		<section class="inputArea">
      <!-- 更新対象絞り込み条件入力エリア -->
      <table class="inputTbl">
        <caption>
          <div class="btnLst">
            <button class="confBtn" v-on:click="onConfirmRegisterModalOpen">一括登録</button>
          </div>
        </caption>
      <tbody>
      <tr>
        <!-- 枠 -->
        <th>予約枠</th>
        <td>
          <select v-model="inputForm.waku">
            <option v-for="item in inputForm.wakuList" v-bind:value="item.waku" v-bind:key="item.waku">
              {{item.wknm}}
            </option>
          </select>
          <dl class="computed">
            <dt>枠管理区分</dt><dd>{{computedStrKrkb}}</dd>
            <dt>カウント方法</dt><dd>{{computedStrCcd1}}</dd>
          </dl>
        </td>
      </tr>
      <!-- 設定日範囲 -->
      <tr>
        <th>設定日範囲</th>
        <td class="dayForm">
          <ul>
          <li>
            <select v-model="inputForm.startYear">
              <option value=0>未選択</option>
              <option v-for="item in inputForm.listYear" v-bind:key="item">
                {{item}}
              </option>
            </select>
          </li>
          <li>
            <select v-model="inputForm.startMonth">
              <option value=0>未選択</option>
              <option v-for="item in inputForm.listMonth" v-bind:key="item">
                {{item}}
              </option>
            </select>
          </li>
          <li>
            <select v-model="inputForm.startDate">
              <option value=0>未選択</option>
              <option v-for="item in computedListStartDate" v-bind:key="item">
                {{item}}
              </option>
            </select>
          </li>
          </ul>
          <ul>
           <li>
            <select v-model="inputForm.endYear">
              <option value=0>未選択</option>
              <option v-for="item in inputForm.listYear" v-bind:key="item">
                {{item}}
              </option>
            </select>
          </li>
          <li>
            <select v-model="inputForm.endMonth">
              <option value=0>未選択</option>
              <option v-for="item in inputForm.listMonth" v-bind:key="item">
                {{item}}
              </option>
            </select>
          </li>
          <li>
            <select v-model="inputForm.endDate">
              <option value=0>未選択</option>
              <option v-for="item in computedListEndDate" v-bind:key="item">
                {{item}}
              </option>
            </select>
          </li>
          </ul>
        </td>
      </tr>
      <!-- 曜日 -->
      <tr>
        <th>
          曜日
        </th>
        <td>
          <label for="sun" class="checkbox"><input type="checkbox" name="day" id="sun" value="1" v-model="inputForm.days"><span>日曜</span></label>
          <label for="mon" class="checkbox"><input type="checkbox" name="day" id="mon" value="2" v-model="inputForm.days"><span>月曜</span></label>
          <label for="tue" class="checkbox"><input type="checkbox" name="day" id="tue" value="3" v-model="inputForm.days"><span>火曜</span></label>
          <label for="wed" class="checkbox"><input type="checkbox" name="day" id="wed" value="4" v-model="inputForm.days"><span>水曜</span></label>
          <label for="thu" class="checkbox"><input type="checkbox" name="day" id="thu" value="5" v-model="inputForm.days"><span>木曜</span></label>
          <label for="fri" class="checkbox"><input type="checkbox" name="day" id="fri" value="6" v-model="inputForm.days"><span>金曜</span></label>
          <label for="sat" class="checkbox"><input type="checkbox" name="day" id="sat" value="7" v-model="inputForm.days"><span>土曜</span></label>
        </td>
      </tr>
      </tbody>
      </table>

      <section class="settingsArea">
        <h3>設定内容</h3>
        <!-- 設定枠数入力エリア 時間帯 -->
        <div v-if="computedKrkb == '2'">
          <dl><dt>時間帯</dt><dd>枠数</dd></dl>
          <dl v-for="item in inputForm.tmznInputList" v-bind:key="item.tmzn">
            <dt>{{getZnnm(item.tmzn)}}</dt>
            <dd><input type="text" maxlength="3" placeholder="XXX" v-model="item.wakuCnt1"></dd>
          </dl>
        </div>
        <div v-else>
          <p><b>枠数</b><input type="text" maxlength="3" placeholder="XXX" v-model="inputForm.wakuCnt1"></p>
        </div>
    </section>


    </section>
    </section>
    <!-- △ mainContents END -->
    <!-- モーダルWindow S -->
    <modalWindow v-show="modal.validationError.isShow" v-on:close="onValidationErrorModalClose">
      <dt slot="modal-header">入力エラー</dt>
      <dd slot="modal-body">
        <errorMessageBox :errorMessages="modal.validationError.messages"></errorMessageBox>
      </dd>
      <dd slot="modal-footer"><a href="javascript:void(0)" v-on:click="onValidationErrorModalClose">閉じる</a></dd>
    </modalWindow>
    <!-- モーダルWindow E -->
    <!-- モーダルWindow S -->
    <modalWindow v-show="modal.systemError.isShow" v-on:close="onSystemErrorModalClose">
      <dt slot="modal-header">システムエラー</dt>
      <dd slot="modal-body">
        <errorMessageBox :errorMessages="modal.systemError.messages"></errorMessageBox>
      </dd>
      <dd slot="modal-footer"><a href="javascript:void(0)" v-on:click="onSystemErrorModalClose">閉じる</a></dd>
    </modalWindow>
    <!-- モーダルWindow E -->
    <!-- モーダルWindow S -->
    <modalWindow v-show="modal.confirmRegister.isShow" v-on:close="onConfirmRegisterModalClose">
      <dt slot="modal-header">確認</dt>
      <dd slot="modal-body">
        <errorMessageBox :errorMessages="modal.confirmRegister.messages"></errorMessageBox>
        <ul class="btnLst">
          <li><button v-on:click="onRegister">OK</button></li>
          <li><button v-on:click="onConfirmRegisterModalClose">キャンセル</button></li>
        </ul>
      </dd>
    </modalWindow>
    <!-- モーダルWindow E -->
    <!-- モーダルWindow S -->
    <modalWindow v-show="modal.registerFinished.isShow" v-on:close="onRegisterFinishedModalClose">
      <dt slot="modal-header">確認</dt>
      <dd slot="modal-body">
        <errorMessageBox :errorMessages="modal.registerFinished.messages"></errorMessageBox>
        <ul class="btnLst">
          <li><button v-on:click="onRegisterFinishedModalClose">閉じる</button></li>
        </ul>
      </dd>
    </modalWindow>
    <!-- モーダルWindow E -->
  </div>
</template>
<script>
  import { WWKKRBulkApi } from '@/api'
  import * as ErrorCodes from '@/components/Utility/error-codes'
  import ErrorMessageBox from '@/components/Utility/ErrorMessageBox'
  import ModalWindow from '@/components/Utility/ModalWindow'
	import * as UtilityConsoleLog from '@/components/Utility/UtilityConsoleLog'

  export default {
    name: 'MasterWWKKRBulk',
    // 使用コンポーネント
    components: {
      // エラーメッセージ
      errorMessageBox: ErrorMessageBox,
      // モーダルウィンドウ
      modalWindow: ModalWindow
    },
    data() {
      return {
        // 入力フォーム
        inputForm: {

          // 予約枠
          waku: '',

          // 年のプルダウンリスト
          listYear: [],

          // 月のプルダウン内容
          listMonth: [
            1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12
          ],

          // 枠のプルダウンリスト
          wakuList: [],

          // 時間帯リスト
          tmznList: [],

          // 設定日範囲　開始年
          startYear: 0,
          // 設定日範囲　開始月
          startMonth: 0,
          //  設定日範囲　開始日付
          startDate: 0,

          // 設定日範囲　終了年
          endYear: 0,
          // 設定日範囲　終了月
          endMonth: 0,
          // 設定日範囲　終了日付
          endDate: 0,

          // 曜日
          // 1: 日曜、2: 月曜、3:火曜、4:水曜、5: 木曜、6:金曜、7:土曜
          days: [],

          // 枠管理区分 2:時間帯の場合の設定枠数
          // tmzn: 時間帯コード
          // wakuCnt1: 設定枠数
          tmznInputList: [],

          // 枠管理区分が1:時間帯の場合の設定枠数
          wakuCnt1: 0
        },
        // モーダルウィンドウ
        modal: {
          validationError: {
            messages: [],
            isShow: false
          },
          systemError: {
            messages: [
							'システムエラーです。',
							'内容をもう一度ご確認ください。'
						],
            isShow: false
          },
          confirmRegister: {
            messages: [
							'登録しますか？'
						],
            isShow: false
          },
          registerFinished: {
            messages: [
              '一括登録が終了しました。'
            ],
            isShow: false
          }
        }
      }
    },
    // 算出プロパティ
    computed: {
      // 設定日範囲　開始日　日付のプルダウン内容を生成
      computedListStartDate: function () {

        var tempListDate = []

        // 当月の最終日の求め方
        // 本来8月なら第二引数（月）は7を与えるべきだが
        // 本来8月なら第三引数（日）に0を与えて
        // 次月の最初の日（1日）より一日前（0日）で
        // 当月の最終日を求める
        var lastDate = new Date(
          this.inputForm.startYear,
          this.inputForm.startMonth, 0).getDate()

        for (var i = 1; i <= lastDate; i++) {
          tempListDate.push(i)
        }

        return tempListDate
      },
      // 設定日範囲　終了日　日付のプルダウン内容を生成
      computedListEndDate: function () {

        var tempListDate = []

        // 当月の最終日の求め方
        // 本来8月なら第二引数（月）は7を与えるべきだが
        // 本来8月なら第三引数（日）に0を与えて
        // 次月の最初の日（1日）より一日前（0日）で
        // 当月の最終日を求める
        var lastDate = new Date(
          this.inputForm.endYear,
          this.inputForm.endMonth, 0).getDate()

        for (var i = 1; i <= lastDate; i++) {
          tempListDate.push(i)
        }

        return tempListDate
      },
      // 枠管理区分（枠プルダウンに依存）
      computedKrkb: function() {
        return this.getKrkb()
      },
      // 枠管理区分の文字列を出力（枠プルダウンに依存）
      computedStrKrkb: function() {

        var tempKrkb = ''
        var result = ''

        tempKrkb = this.getKrkb()

        if ('2' == tempKrkb) {
          result = '時間'
        }
        else {
          result = '日'
        }

        return result
      },
      // カウント方法の文字列を出力（枠プルダウンに依存）
      computedStrCcd1: function() {

        var tempCcd1 = ''
        var result = ''

        var tempData = this.inputForm.wakuList.filter((item)=>{
          return item.waku  == this.inputForm.waku
        })

        if(tempData.length == 1) {
          tempCcd1 = tempData[0].ccd1
        }

        if ('1' == tempCcd1) {
          result = '実人数'
        }
        else {
          result = '延人数'
        }

        return result
      }
    },
    watch: {
      'inputForm.waku': function(newWaku, oldWaku){
        // 予約枠の選択値に変更があれば
        // 初期値に戻す

        for(var i=0;i<this.inputForm.tmznInputList.length;i++){
            this.inputForm.tmznInputList[i].wakuCnt1 = 0
        }

        this.inputForm.wakuCnt1 = 0
      }
    },
    created: function () {
      UtilityConsoleLog.consoleLog('MasterWWKKRBulk::created Start')

      this.firstDisplay();

      UtilityConsoleLog.consoleLog('MasterWWKKRBulk::created End')
    },
    methods: {
      // 初期表示
      firstDisplay: function() {
        UtilityConsoleLog.consoleLog('MasterWWKKRBulk::firstDisplay Start')

        // 非同期通信
        WWKKRBulkApi.FirstDisplay({
          token: this.$store.state.auth.token,
          ircd: this.$store.state.auth.ircd
        }).then(({ responce }) => {

          if (responce.data.errorCode == ErrorCodes.ERRORCODE_DEFAULT) {

            this.inputForm.waku = responce.data.waku

            this.inputForm.startYear = responce.data.currentDateTime.YYYY
            this.inputForm.startMonth = responce.data.currentDateTime.MM
            this.inputForm.startDate = responce.data.currentDateTime.DD
            this.inputForm.endYear = responce.data.currentDateTime.YYYY
            this.inputForm.endMonth = responce.data.currentDateTime.MM
            this.inputForm.endDate = responce.data.currentDateTime.DD

            this.inputForm.listYear = responce.data.listYear
            this.inputForm.wakuList = responce.data.wakuList
            this.inputForm.tmznList = responce.data.tmznList

            //  枠管理区分 2:時間帯の場合の設定枠数入力フォームを作成
            var tempTmznInputList = []

            for(var i=0;i<this.inputForm.tmznList.length;i++){
              tempTmznInputList.push({
                tmzn: this.inputForm.tmznList[i].tmzn,
                wakuCnt1: 0
              })
            }

            this.inputForm.tmznInputList = tempTmznInputList

          } else if (responce.data.errorCode == ErrorCodes.ERRORCODE_SIMPLEITEM
              || responce.data.errorCode == ErrorCodes.ERRORCODE_SYSTEM
              || responce.data.errorCode == ErrorCodes.ERRORCODE_DB) {
              // システム、DBエラー時
              this.onSystemErrorModalOpen()   
          }

        }).catch(() => {
          this.onSystemErrorModalOpen()
        }).finally(() => {
	        UtilityConsoleLog.consoleLog('MasterWWKKRBulk::firstDisplay End')
	      })
      },
      // 一括登録押下時
      onRegister: function() {
        UtilityConsoleLog.consoleLog('MasterWWKKRBulk::onRegister Start')

        // 枠管理区分　2:時間帯　の設定枠数、
        // 枠管理区分　1:日　の設定枠数を
        // それぞれ送信用に整形する
        var objectOfTime = {
          tmzns: [],
          wakuCnt1s: []
        }
        
        var tempCntOfDate = 0

        if('2' == this.getKrkb()){
          objectOfTime = this.getInfoTmznInputList()
        } else {
          tempCntOfDate = this.inputForm.wakuCnt1
        }

        // 非同期通信this.inputForm.wakuCnt1
        WWKKRBulkApi.Register({
          token: this.$store.state.auth.token,
          ircd: this.$store.state.auth.ircd,
          waku: this.inputForm.waku,
          startYear: this.inputForm.startYear,
          startMonth: this.inputForm.startMonth,
          startDate: this.inputForm.startDate,
          endYear: this.inputForm.endYear,
          endMonth: this.inputForm.endMonth,
          endDate: this.inputForm.endDate,
          endDate: this.inputForm.endDate,
          days: this.inputForm.days,
          tmzns: objectOfTime.tmzns,
          tmznWakuCnt1: objectOfTime.wakuCnt1s,
          wakuCnt1: tempCntOfDate
        }).then(({ responce }) => {

          this.onConfirmRegisterModalClose()

          if (responce.data.errorCode == ErrorCodes.ERRORCODE_DEFAULT) {
            
            this.onRegisterFinishedModalOpen()

          } else if (responce.data.errorCode == ErrorCodes.ERRORCODE_INPUTSIMPLEITEM
            || responce.data.errorCode == ErrorCodes.ERRORCODE_INPUTCORRECTION) {

              // 入力エラーダイアログを流用する
              this.onValidationErrorModalOpen(responce.data.errorMessagesList)

          } else if (responce.data.errorCode == ErrorCodes.ERRORCODE_SIMPLEITEM
              || responce.data.errorCode == ErrorCodes.ERRORCODE_SYSTEM
              || responce.data.errorCode == ErrorCodes.ERRORCODE_DB) {
              // システム、DBエラー時
              this.onSystemErrorModalOpen()
          }
          
        }).catch(() => {
          this.onSystemErrorModalOpen()
        }).finally(() => {
	        UtilityConsoleLog.consoleLog('MasterWWKKRBulk::onRegister End')
	      })
      },
      // 戻る押下時
      onCancel: function() {
        UtilityConsoleLog.consoleLog('MasterWWKKRBulk::onCancel Start')

        this.$router.push("/MasterWWKKR")

        UtilityConsoleLog.consoleLog('MasterWWKKRBulk::onCancel End')
      },
      // 一括登録ボタン押下時（登録確認ダイアログを開く前）
      validationOnRegister: function(){
      
        UtilityConsoleLog.consoleLog('MasterWWKKRBulk::validationOnRegister Start')
        
        // フロント用エラーメッセージ
        var resultErrorMessages = []
        
        // 枠数の数値チェック
        if('2' == this.getKrkb()) {

            for(var i=0;i<this.inputForm.tmznInputList.length;i++){
              var tempNum = this.checkNumber(this.inputForm.tmznInputList[i].wakuCnt1)
              if (tempNum == -1) {
                var tempZnnm = this.getZnnm(this.inputForm.tmznList[i].tmzn)
                resultErrorMessages.push( '時間帯:' + tempZnnm + 'の枠数が整数値で入力されていません。')
              }
            }

        } else {
          var tempNum = this.checkNumber(this.inputForm.wakuCnt1)
          if (tempNum == -1) {
            resultErrorMessages.push( '枠数が整数値で入力されていません。')
          }
        }
        
        UtilityConsoleLog.consoleLog('MasterWWKKRBulk::validationOnRegister End')
        
        return resultErrorMessages
      },
      // Number型がString型になっていた場合数値に直して返す
      checkNumber: function (value0) {

        UtilityConsoleLog.consoleLog('MasterWWKKRBulk::checkNumber Start')

        var tempType = typeof value0
        var tempValue = 0

        if (tempType == 'number') {
          tempValue = value0
        } else {

          var regexp = new RegExp(/^[0-9]+(\.[0-9]+)?$/)
          var flagNumber = regexp.test(value0)

          // 文字列型の数値ではないとき
          if (!flagNumber) {
            tempValue = -1
          } else {
            tempValue = Number(value0)
          }
        }

        UtilityConsoleLog.consoleLog('MasterWWKKRBulk::checkNumber End')

        return tempValue
      },
      // 時間帯を時間帯名に変換する
      getZnnm: function (in_tmzn) {

        var result = ''

        for (var i = 0; i < this.tmznList.length; i++) {
          if (in_tmzn == this.tmznList[i].tmzn) {
            result = this.tmznList[i].znnm
          }
        }
        return result;
      },
      // 枠管理区分（枠プルダウンに依存）
      getKrkb: function() {

        var tempKrkb = ''

        var tempData = this.inputForm.wakuList.filter((item)=>{
          return item.waku  == this.inputForm.waku
        })

        if(tempData.length == 1) {
          tempKrkb = tempData[0].krkb
        }

        return tempKrkb
      },
      // 枠管理区分 2:時間帯
      getInfoTmznInputList: function(){
      
        var resultData = []
        var tempTmzns = []
        var tempWakuCnt1s = []

        for(var i=0;i<this.inputForm.tmznInputList.length;i++) {
          tempTmzns.push(this.inputForm.tmznInputList[i].tmzn)
          tempWakuCnt1s.push(this.inputForm.tmznInputList[i].wakuCnt1)
        }

        resultData = {
            tmzns: tempTmzns,
            wakuCnt1s: tempWakuCnt1s
        }

        return resultData
      },
      // バリデーションエラーモーダルとしてエラーモーダルを開く
      // errorMessagesは文字列配列であること
      // errorMessages = [
      //  'エラーメッセージ'
      // ]
      onValidationErrorModalOpen: function (errorMessages) {
        UtilityConsoleLog.consoleLog('MasterWWKKRBulk::onValidationErrorModalOpen Start')

				var tempMessages = [
					'入力エラーです。',
					'以下の内容をもう一度ご確認ください'
				]
				
				errorMessages.forEach((item)=>{
					tempMessages.push(item)
				})

				this.modal.validationError.messages = tempMessages
        this.modalOpen('validationError')

        UtilityConsoleLog.consoleLog('MasterWWKKRBulk::onValidationErrorModalOpen End')
      },
      // バリデーションエラーモーダルとしてエラーモーダルを閉じる
      onValidationErrorModalClose: function () {
        UtilityConsoleLog.consoleLog('MasterWWKKRBulk::onValidationErrorModalClose Start')

        this.modalClose('validationError')

        UtilityConsoleLog.consoleLog('MasterWWKKRBulk::onValidationErrorModalClose End')
      },
      // システムエラーモーダルとしてエラーモーダルを開く
      onSystemErrorModalOpen: function () {
        UtilityConsoleLog.consoleLog('MasterWWKKRBulk::onSystemErrorModalOpen Start')

        this.modalOpen('systemError')

        UtilityConsoleLog.consoleLog('MasterWWKKRBulk::onSystemErrorModalOpen End')
      },
      // システムエラーモーダルウィンドウの閉じるボタン
      onSystemErrorModalClose: function () {
        UtilityConsoleLog.consoleLog('MasterWWKKRBulk::onSystemErrorModalClose Start')

        this.modalClose('systemError')
        this.$router.push("/AdminLogin")

        UtilityConsoleLog.consoleLog('MasterWWKKRBulk::onSystemErrorModalClose End')
      },
      // 更新確認モーダルを開く
      onConfirmRegisterModalOpen: function () {
        UtilityConsoleLog.consoleLog('MasterWWKKRBulk::onConfirmRegisterModalOpen Start')

        // フロント用エラーメッセージ
        var tempErrorMessages = []
        // 入力チェック
        var tempErrorMessages = this.validationOnRegister()

        // 一件でもエラーがあれば入力エラーモーダルウィンドウを開き、処理を中断する
        if( tempErrorMessages.length > 0 ){
          this.onConfirmRegisterModalClose()
          this.onValidationErrorModalOpen(tempErrorMessages)
          return
        }

        this.modalOpen('confirmRegister')

        UtilityConsoleLog.consoleLog('MasterWWKKRBulk::onConfirmRegisterModalOpen End')
      },
      // 更新確認モーダルを閉じる
      onConfirmRegisterModalClose: function () {
        UtilityConsoleLog.consoleLog('MasterWWKKRBulk::onConfirmRegisterModalClose Start')

        this.modalClose('confirmRegister')

        UtilityConsoleLog.consoleLog('MasterWWKKRBulk::onConfirmRegisterModalClose End')
      },
      // 更新正常終了時モーダルとしてエラーモーダルを開く
      onRegisterFinishedModalOpen: function () {
        UtilityConsoleLog.consoleLog('MasterWWKKRBulk::onRegisterFinishedModalOpen Start')

        this.modalOpen('registerFinished')

        UtilityConsoleLog.consoleLog('MasterWWKKRBulk::onRegisterFinishedModalOpen End')
      },
      // 更新正常終了時モーダルウィンドウの閉じるボタン
      onRegisterFinishedModalClose: function () {
        UtilityConsoleLog.consoleLog('MasterWWKKRBulk::onRegisterFinishedModalClose Start')

        this.modalClose('registerFinished')

        UtilityConsoleLog.consoleLog('MasterWWKKRBulk::onRegisterFinishedModalClose End')
      },
      // モーダルウィンドウを開く
      modalOpen: function (modalName) {
        UtilityConsoleLog.consoleLog('MasterWWKKRBulk::modalOpen Start')

				// すべてのモーダルを閉じる
				this.allModalClose()

        this.modal[modalName].isShow = true

        UtilityConsoleLog.consoleLog('MasterWWKKRBulk::modalOpen End')
      },
      // モーダルウィンドウを閉じる
      modalClose: function (modalName) {
        UtilityConsoleLog.consoleLog('MasterWWKKRBulk::modalClose Start')

        this.modal[modalName].isShow = false

        UtilityConsoleLog.consoleLog('MasterWWKKRBulk::modalClose End')
      },
			// 全てのモーダルを閉じる
			allModalClose: function() {  
				for(var key in this.modal) {
					this.modal[key].isShow = false
				}
			},
      // 時間帯を時間帯名に変換する
      getZnnm: function (in_tmzn) {

        var result = ''

        for (var i = 0; i < this.inputForm.tmznList.length; i++) {
          if (in_tmzn == this.inputForm.tmznList[i].tmzn) {
            result = this.inputForm.tmznList[i].znnm
          }
        }
        return result;
      },
    }
  }

</script>



// WEBPACK FOOTER //
// src/components/Admin/Master/WWKKR/MasterWWKKRBulk.vue